import { NotFoundIcon } from '../../components/svg/NotFoundIcon';

export const OrderNotFound = () => {
  return (
    <div>
      <div className="mx-auto mb-[10px] h-auto w-[18rem] m800:mt-[50px] m800:w-[20rem]">
        <NotFoundIcon />
      </div>
      <div className="mx-auto max-w-[650px] p-[37px] text-denim-15">
        <div className="mb-[20px] text-center text-[32px] font-bold leading-[normal]">
          Sorry, we can't find that order
        </div>
        <div className="mx-auto max-w-[436px] text-center text-m font-reg leading-[150%]">
          Oops, we can’t seem to find that order. Double check you’ve copied it
          correctly or get in touch with your supplier for a new one.
        </div>
      </div>
    </div>
  );
};
